import { Images } from "@assets/images";
import { Form, Formik } from "formik";
import { FormControl } from "../form-control";
import Input from "../input";
import Button from "../button";
import { createForgotPasswordValidationSchema } from "@app/validations";
import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";

const ForgotPasswordModal = ({ portalDialogRef }: PortalDialogProps) => {
  const onSubmit = (values: { username?: string }) => {
    if (values.username) {
      portalDialogRef.close({ username: values.username });
    }
  };

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[443px] px-[34px] py-10 bg-white rounded-xl">
        <div className="flex justify-center">
          <img className="w-28" src={Images.LogoText.default} alt="" />
        </div>
        <div className="mt-4 font-[SVN-Gilroy] font-semibold text-xl text-center neutral-n80">
          Quên mật khẩu
        </div>
        <div className="mt-2 black-30 text-sm text-center black-30 font-[SVN-Gilroy] font-medium">
          Nhập thông tin để thay đổi mật khẩu
        </div>
        <Formik
          initialValues={{
            username: "",
          }}
          onSubmit={onSubmit}
          validationSchema={createForgotPasswordValidationSchema}
          validateOnBlur
          validateOnChange
        >
          <Form>
            <div className="mt-4">
              <FormControl name="username">
                <Input
                  placeholder="Tên đăng nhập"
                  inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                  errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                />
              </FormControl>
            </div>

            <Button
              type="submit"
              containerClassName="mt-12 mx-auto"
              label="Tiếp tục"
              labelClassName="font-[SVN-Gilroy]"
              width=""
              size="l"
              className="text-lg font-bold px-11 rounded-3xl"
            />
          </Form>
        </Formik>
      </div>
    </Modal>
  );
};

export default ForgotPasswordModal;
